module.exports = __webpack_public_path__ + "img/index-ico9.2a59d7c1.png";